import { gql } from '@apollo/client';
import { ADDRESS_FRAGMENT } from './addressFragment';
import { DOCUMENT_FRAGMENT } from './documentFragment';
import { AGENCY_COVERAGE_FRAGMENT } from './agencyCoverageFragment';

export const AGENCY_CONTRACT_FRAGMENT = gql`
  fragment AgencyContractFragment on AgencyContract {
    id
    legalBusinessName
    signatureName
    signatureTitle
    contactEmail
    contactName
    contactPhone
    contactTitle
    dba
    address {
      ...AddressFragment
    }
    document {
      ...DocumentFragment
    }
  }
  ${DOCUMENT_FRAGMENT}
  ${ADDRESS_FRAGMENT}
  ${AGENCY_COVERAGE_FRAGMENT}
`;
